module.exports = __webpack_public_path__ + "static/media/nauka-programowania-dla-dzieci-inf3-4.74714760.png";